import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import TableWidget from "../../../components/tables/TableWidget";
import {
  activeTransportsTableHeader,
  getactiveTransportsTableData,
} from "./components/tableConfigs/activeTransportsTableConfig";
import ActiveTransportActionButton from "./components/TableActionsButtonsComponent/ActiveTransportsActionButton";
import EndActiveTransportModal from "./components/EndActiveTransportModal";
import {
  fetchActiveTransports,
  fetchIntranodesNomenclatures,
  fetchRoutesNomenclatures,
} from "../../../redux/api/transport.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

function ActiveTransports() {
  const dispatch = useAppDispatch();

  const {
    transport: {
      activeTransports: {
        data: { data: activeTransports },
        isLoading,
      },
      routesNomenclatures: {
        data: { data: routesNomenclatures },
        isLoading: isLoadingRoutesNomenclatures,
      },
      intranodesNomenclatures: {
        data: { data: intranodesNomenclatures },
        isLoading: isLoadingIntranodesNomenclatures,
      },
    },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  useEffect(() => {
    dispatch(
      fetchRoutesNomenclatures({
        perPage: 10000,
      }),
    );

    dispatch(
      fetchIntranodesNomenclatures({
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    if (action.tableFilter && action.tableSearch && action.tableFilter) {
      dispatch(
        fetchActiveTransports({
          perPage: 9999,
          tip_ruta: action.tableFilter.tip_ruta,
          masina: action.tableSearch.masina,
          ruta: action.tableFilter.ruta,
          ruta_intranod: action.tableFilter.ruta_intranod,
        }),
      );
    }
  };

  const activeTransportsTableHeaderNew = useMemo(
    () =>
      activeTransportsTableHeader.map((item) => {
        if (!isLoadingRoutesNomenclatures && item.value === "ruta") {
          const routesDropdown = routesNomenclatures?.map(
            ({ denumire, id_ruta }) => ({
              label: denumire,
              value: id_ruta,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...routesDropdown],
            ...item,
          };
        }
        if (
          !isLoadingIntranodesNomenclatures &&
          item.value === "ruta_intranod"
        ) {
          const internodeRoutesDropdown = intranodesNomenclatures?.map(
            ({ denumire, id_ruta_intranod }) => ({
              label: denumire,
              value: id_ruta_intranod,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: 0 },
              ...internodeRoutesDropdown,
            ],
            ...item,
          };
        }
        return item;
      }),
    [
      intranodesNomenclatures,
      isLoadingIntranodesNomenclatures,
      isLoadingRoutesNomenclatures,
      routesNomenclatures,
    ],
  );

  return (
    <>
      <EndActiveTransportModal />
      <TableWidget
        tableTitle="Transporturi active"
        tableHeaderData={activeTransportsTableHeaderNew}
        tableItemsData={getactiveTransportsTableData(activeTransports)}
        tableLoading={isLoading}
        ActionButtonsComponent={(props: any) => (
          <ActiveTransportActionButton {...props} />
        )}
        handleTableActions={handleTableActions}
        withTablePagination={false}
        borderedRow
      />
    </>
  );
}

export default ActiveTransports;
